// disable auto-story

import { useRef, useState } from 'react';
import useOnClickOutside from 'use-onclickoutside';
import { BladeDivider, BladeLink, BladeSubmenu } from './blade-item';
import { isNavigationDivider, isNavigationLink, isNavigationSubmenu } from './is-navigation-item';

interface BladeLevelProps extends Omit<NavigationSubmenu, 'text'> {
  className?: string;
  level?: number; // 0 indexed
  style?: React.CSSProperties;
}

function BladeItem({ item }: { item: NavigationItem }) {
  if (isNavigationDivider(item)) return <BladeDivider />;
  if (isNavigationLink(item)) return <BladeLink {...item} />;
}

/**
 * Represents one column of a subnav within a dropdown blade.
 * For example "Overview, Academic, Test Prep" within Tutoring, and then "1-on-1 Private Tutoring, Online Tutoring".
 * It handles rendering selected subnav in a flat structure. For this the Blade should have flex styling.
 */
function BladeLevel({ items, level = 0, style = {} }: BladeLevelProps) {
  const [openBladeIndex, setOpenBladeIndex] = useState(-1);
  const areaRef = useRef(null);
  useOnClickOutside(areaRef, () => setOpenBladeIndex(-1));

  if (!items) return null;

  const multiColumnClasses =
    level > 0 && items.length > 11 ? 'grid grid-cols-2 min-w-[380px]' : 'min-w-[190px]';

  return (
    <>
      <ul
        className={`flex flex-col mr-1 py-2 px-3 bg-white text-black shadow-md relative ${multiColumnClasses}`}
        ref={areaRef}
        style={style}
      >
        {items.map((item, index) =>
          isNavigationSubmenu(item) ? (
            <BladeSubmenu
              isOpen={openBladeIndex === index}
              key={index}
              level={level + 1}
              onOpen={() => setOpenBladeIndex(index)}
              {...item}
            />
          ) : (
            <BladeItem item={item} key={index} />
          )
        )}
      </ul>
    </>
  );
}

export default BladeLevel;
